module.exports = __webpack_public_path__ + "img/Balthzar.55e6e78d.png";